import { Maybe } from "lib/types";

export const groszToFixedZloty = (price?: Maybe<number>) => {
  return (price ? price / 100 : 0).toFixed(2);
};
